export const CLINIC_MANAGE_URL_PROD = "";
export const MASTER_CLINIC_ID = "d11a07cf-06b7-45c3-bd70-926dbd0e4fd9";
export const MASTER_CLINIC_NAME = "default_master_clinic";
export const MASTER_CLINIC_DISABLED_ITEMS = ["clinic.basedOnClinic"];
export const DEMO_CLINIC_ID = "8da759af-5354-4b7b-ae64-5c50d2adcaa1";
export const AGENT_CASE_API_KEY = "FTTpzynamoEAesCzfW8j3zWHiB1os8Y9QvPmbKZb";
